import dateUtils from "../utils/date";

export default class Pagination {
  constructor(obj) {
    obj = obj || {};

    this.page = obj.page || 1;
    this.quantity = obj.quantity;
    this.sortBy = obj.sortBy;
    this.sortDesc = obj.sortDesc == 'true' || obj.sortDesc == true;
    this.pageKey = obj.pageKey;
    this.tieBreakerKey = obj.tieBreakerKey;
    this.tieBreakerSortBy = obj.tieBreakerSortBy;
  }

  getPaginationQuery() {
    if (!this.quantity || this.quantity < 0) {
      return '';
    }

    if (this.pageKey) {
      return `
        LIMIT ${this.quantity}
      `;
    }

    return `
      OFFSET ${(this.page - 1) * this.quantity} ROWS FETCH NEXT ${this.quantity} ROWS ONLY
    `;
  }

  getPaginationWhereCondition() {
    if (!this.pageKey) {
      return '';
    }

    let directionSignal = this.sortDesc ? '<' : '>';

    let pageKey = this.pageKey;

    if (dateUtils.isStringIsoDate(pageKey)) {
      pageKey = `'${pageKey}'::timestamptz`;
    }

    let conditionPageKey = `${this.sortBy} ${directionSignal} ${pageKey}`;

    if (!this.tieBreakerKey || this.sortBy == this.tieBreakerSortBy) {
      return conditionPageKey;
    }

    let tieBreakerKey = this.tieBreakerKey;

    if (dateUtils.isStringIsoDate(tieBreakerKey)) {
      tieBreakerKey = `'${tieBreakerKey}'::timestamptz`;
    }

    let conditionTieBreaker = `(${this.sortBy} = ${pageKey} AND ${this.tieBreakerSortBy} ${directionSignal} ${tieBreakerKey})`;

    return `
      (${conditionPageKey} OR ${conditionTieBreaker})
    `;
  }

  getOrderQuery() {
    let sortDirection = this.sortDesc ? 'DESC' : 'ASC';
    let sortBy = `ORDER BY ${this.sortBy || 'id'} ${sortDirection}`;

    if (!this.tieBreakerSortBy || this.sortBy == this.tieBreakerSortBy) {
      return sortBy;
    }

    return `
      ${sortBy}, ${this.tieBreakerSortBy} ${sortDirection}
    `;
  }

}
